var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPupilProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.61133 5.16699C3.61133 2.40557 5.8499 0.166992 8.61133 0.166992C11.3728 0.166992 13.6113 2.40557 13.6113 5.16699C13.6113 7.92842 11.3728 10.167 8.61133 10.167C5.8499 10.167 3.61133 7.92842 3.61133 5.16699ZM8.61133 8.16699C10.2682 8.16699 11.6113 6.82385 11.6113 5.16699C11.6113 3.51014 10.2682 2.16699 8.61133 2.16699C6.95447 2.16699 5.61133 3.51014 5.61133 5.16699C5.61133 6.82385 6.95447 8.16699 8.61133 8.16699Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95447 13.5101C1.45418 15.0104 0.611328 17.0453 0.611328 19.167H2.61133C2.61133 17.5757 3.24347 16.0496 4.36869 14.9244C5.49391 13.7991 7.02003 13.167 8.61133 13.167C10.2026 13.167 11.7288 13.7991 12.854 14.9244C13.9792 16.0496 14.6113 17.5757 14.6113 19.167H16.6113C16.6113 17.0453 15.7685 15.0104 14.2682 13.5101C12.7679 12.0098 10.7331 11.167 8.61133 11.167C6.4896 11.167 4.45476 12.0098 2.95447 13.5101Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPupilProfile);
export default __webpack_public_path__ + "static/media/pupil_profile.a4123c02.svg";
export { ForwardRef as ReactComponent };